module.exports = __webpack_public_path__ + "static/img/wlzsbanner.7ada28c3.png";